__turbopack_context__.v({
  "burgerbutton": "HeraHeader-module-scss-module__fLdbtW__burgerbutton",
  "heraheader": "HeraHeader-module-scss-module__fLdbtW__heraheader",
  "items": "HeraHeader-module-scss-module__fLdbtW__items",
  "logoIcon": "HeraHeader-module-scss-module__fLdbtW__logoIcon",
  "logoIcon1": "HeraHeader-module-scss-module__fLdbtW__logoIcon1",
  "navLink": "HeraHeader-module-scss-module__fLdbtW__navLink",
  "navbarMenu": "HeraHeader-module-scss-module__fLdbtW__navbarMenu",
  "open": "HeraHeader-module-scss-module__fLdbtW__open",
  "sidebarBtn": "HeraHeader-module-scss-module__fLdbtW__sidebarBtn",
  "sidebarContent": "HeraHeader-module-scss-module__fLdbtW__sidebarContent",
  "sidebarWrapper": "HeraHeader-module-scss-module__fLdbtW__sidebarWrapper",
  "userBar": "HeraHeader-module-scss-module__fLdbtW__userBar",
});
